import { FC } from 'react';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import Swal from 'sweetalert2';
import { MenuCommand } from '../../../services/command';
import { useTranslation } from 'react-i18next';
import { SCUIMenuManagementDialogContent } from '../SCUIMenuManagementDialogContent/SCUIMenuManagementDialogContent';
import MenuIcon from '@mui/icons-material/Menu';

interface IProps {
    selectedRow?: any;
    open?: boolean;
    onClose?: any;
    parent?: any;
    refresh?: any;
    menuappList?: any;
    menuWithApp?: any;
}
export const SCUIMenuManagementDialog: FC<IProps> = ({
    selectedRow = null,
    open = false,
    onClose,
    parent,
    refresh,
    menuappList,
    menuWithApp,
}) => {
    const { t } = useTranslation();
    const addMenu = async (addedMenuItem: any) => {
        if (addedMenuItem.parentMenuId === undefined) {
            Swal.fire(t('general.emptyFieldControlText'), ' ', 'error');
        } else {
            MenuCommand.PostMenuAdd(addedMenuItem)
                .then(() => {
                    onClose();
                    refresh();
                    Swal.fire(t('general.added'), ' ', 'success');
                })
                .catch((error: any) => {
                    console.log('Hata :>> ', error);
                })
                .finally(() => {});
        }
    };
    const editMenu = async (editedMenuItem: any) => {
        MenuCommand.PutMenuUpdate(editedMenuItem)
            .then(() => {
                onClose();
                refresh();
                Swal.fire(t('general.updated'), ' ', 'success');
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {});
    };
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            slotProps={{
                paper: {
                    sx: {
                        width: '100%',
                        maxWidth: '700px',
                        borderRadius: '12px',
                        border: '1px solid #e3f2fd',
                        boxShadow: '0 12px 40px rgba(25, 118, 210, 0.14), 0 4px 16px rgba(0, 0, 0, 0.08)',
                        overflow: 'hidden',
                    },
                },
            }}
        >
            <DialogTitle
                sx={{
                    background: 'linear-gradient(135deg, #f8f9fa 0%, #e3f2fd 100%)',
                    borderBottom: '1px solid #bbdefb',
                    padding: '14px 20px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                    fontSize: '15px',
                    fontWeight: 700,
                    letterSpacing: '0.01em',
                    color: '#1565c0',
                    lineHeight: 1,
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: 32,
                        height: 32,
                        borderRadius: '8px',
                        backgroundColor: '#fff',
                        border: '1px solid #bbdefb',
                        boxShadow: '0 2px 6px rgba(25, 118, 210, 0.12)',
                    }}
                >
                    <MenuIcon sx={{ fontSize: 18, color: '#1976d2' }} />
                </Box>
                {t('menuManagement.menuInformation')}
            </DialogTitle>
            <SCUIMenuManagementDialogContent
                selectedRow={selectedRow}
                onAddMenu={addMenu}
                onEditMenu={editMenu}
                onCloseMenu={onClose}
                parent={parent}
                menuappList={menuappList}
                menuWithApp={menuWithApp}
            />
        </Dialog>
    );
};
